import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentLocationTypes } from './normalize';

export const fetchShipmentLocationTypesList = createProvider(api.fetchShipmentLocationTypesList)
  .andThen((res) => normalizeShipmentLocationTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
